interface SkeletonProps {
  type?: 'list' | 'card' | 'avatar' | 'text' | 'stat';
  count?: number;
  style?: React.CSSProperties;
}

export default function Skeleton({ type = 'list', count = 3, style }: SkeletonProps) {
  if (type === 'avatar') {
    return (
      <div style={{ display: 'flex', gap: 12, padding: '16px', ...style }}>
        <div className="ios-skeleton" style={{ width: 48, height: 48, borderRadius: '50%' }} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8, justifyContent: 'center' }}>
          <div className="ios-skeleton" style={{ width: '40%', height: 16 }} />
          <div className="ios-skeleton" style={{ width: '60%', height: 13 }} />
        </div>
      </div>
    );
  }

  if (type === 'card') {
    return (
      <div style={{ padding: '0 16px', ...style }}>
        <div className="ios-skeleton" style={{ width: '100%', height: 120, borderRadius: 16 }} />
      </div>
    );
  }

  if (type === 'stat') {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12, padding: '0 16px', ...style }}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="ios-skeleton" style={{ height: 88, borderRadius: 16 }} />
        ))}
      </div>
    );
  }

  if (type === 'text') {
    return (
      <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: 8, ...style }}>
        <div className="ios-skeleton" style={{ width: '30%', height: 16 }} />
        <div className="ios-skeleton" style={{ width: '80%', height: 13 }} />
        <div className="ios-skeleton" style={{ width: '60%', height: 13 }} />
      </div>
    );
  }

  return (
    <div style={{ ...style }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{ display: 'flex', gap: 12, padding: '12px 16px', alignItems: 'center' }}>
          <div className="ios-skeleton" style={{ width: 40, height: 40, borderRadius: '50%' }} />
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div className="ios-skeleton" style={{ width: '35%', height: 17 }} />
            <div className="ios-skeleton" style={{ width: '55%', height: 14 }} />
          </div>
        </div>
      ))}
    </div>
  );
}
